import Vue from 'vue'

var goBackEntity = new Vue({});
export default goBackEntity;